module.exports = __webpack_public_path__ + "img/border_polygon.647a7a3f.svg";